import React, { createContext, useContext } from 'react';

/**
 * ConfigContext
 * 
 * Portal configuration from window.LEP:
 * - primary_color: Brand color
 * - portal_name: Portal title
 * - enable_dark_mode: Boolean
 * - api_base: Base URL for AJAX
 */
const ConfigContext = createContext();

export function ConfigProvider({ children }) {
  const configState = {
    primary_color: window.LEP?.primary_color || '#205ec8',
    portal_name: window.LEP?.portal_name || 'Law Enforcement Portal',
    enable_dark_mode: window.LEP?.enable_dark_mode || true,
    pro_unlocked: !!window.LEP?.pro_unlocked,
    api_base: window.LEP?.api_base || '/wp-admin/admin-ajax.php',
  };

  return (
    <ConfigContext.Provider value={configState}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context;
}
